<template>
  <div>
    <template v-for="(item, index) in arrayList">
      <div v-show="selectedValue == item || selectedValue == 'All'" :key="index" :class="{ 'u-mrgn-top--4': filter }">
        <div v-if="filter" class="u-mrgn-bottom--2">
          <a
            v-if="filterMode === 'product'"
            :href="getTypeUrl(item)"
            data-no-turbolink="true"
            class="u-mrgn-h--4 u-txt--fair u-fg--black"
            >{{ item }}
          </a>
          <span v-else class="u-mrgn-bottom--2 u-mrgn-h--4 u-txt--fair u-fg--black">{{ item }}</span>
        </div>
        <div v-for="(product, index) in products" :key="product.id">
          <ProductItem v-if="itemFilter(product, item)" :product="product" :index="index" from-seo-content />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { generateSeoTypeUrl } from 'shared/helpers/seoMap';
import ProductItem from './ProductItem';

export default {
  name: 'ProductListItem',
  components: {
    ProductItem,
  },
  props: {
    arrayList: {
      type: Array,
      default: () => [],
    },
    selectedValue: {
      type: String,
      default: 'All',
    },
    products: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Boolean,
      default: false,
    },
    filterMode: {
      type: String,
      default: 'product',
    },
  },
  computed: {
    attr() {
      return this.filterMode === 'product' ? 'type' : 'custodian_bank_name';
    },
  },
  methods: {
    getTypeUrl(type) {
      return generateSeoTypeUrl(type);
    },
    itemFilter(product, item) {
      return product && product[this.attr] === item;
    },
  },
};
</script>
